module.exports = __webpack_public_path__ + "images/emoji/dolphin.056198352af18806b161.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/dolphin.png
// module id = qEgU
// module chunks = 14